/**
 * 获取原生用户信息
 */
import userInter from '../plugins/user'
import outStore from '../store/index'

export default {
  methods: {
    getUserInfoFromNative() {
      return new Promise((resolve, reject) => {
        userInter.getUserInfo((params) => {
          if (!params || Object.keys(params).length === 0) {
            reject(Error('获取用户信息失败'))
            return
          }
          outStore.dispatch('setUserInfo', params.user).then()
          outStore.dispatch('setSystemInfo', params.system).then()
          resolve(params)
        })
      })
    }
  }
}
